/**
 * Chat API client. One door: `chatApi.send(...)` handles typed text OR chip taps.
 * Uses axios with the existing auth token header set by AuthContext.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate or retrieve a stable device_id for pre-auth chat continuity.
function getDeviceId() {
  let id = localStorage.getItem('forma_device_id');
  if (!id) {
    id = (crypto?.randomUUID?.() || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem('forma_device_id', id);
  }
  return id;
}

// Detect the user's IANA timezone (e.g. "Asia/Kolkata"). Used by greetings so
// "Good morning" matches the user's local clock, not the server's UTC clock.
function getTimezone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }
  catch { return ''; }
}

const chatApi = {
  bootstrap: () => axios.get(`${API}/chat/bootstrap`, { params: { tz: getTimezone() } }),
  history: ({ since_date, since_ts, before, limit = 100 } = {}) => axios.get(`${API}/chat/history`, { params: { since_date, since_ts, before, limit } }),

  sendMessage: (text) => axios.post(`${API}/chat/send`, {
    message: text,
    device_id: getDeviceId(),
    tz: getTimezone(),
  }),

  sendChip: (chipAction) => axios.post(`${API}/chat/send`, {
    chip_action: chipAction,
    device_id: getDeviceId(),
    tz: getTimezone(),
  }),

  signupChat: (payload) => axios.post(`${API}/auth/signup-chat`, {
    ...payload,
    device_id: getDeviceId(),
    tz: getTimezone(),
  }),

  loginChat: (email, password) => axios.post(`${API}/auth/login-chat`, {
    email, password, device_id: getDeviceId(), tz: getTimezone(),
  }),

  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password`, { email }),

  resetPassword: (token, newPassword) => axios.post(`${API}/auth/reset-password`, {
    token, new_password: newPassword,
  }),

  profilePatch: (field, value) => axios.patch(`${API}/profile`, { field, value }),
};

export default chatApi;
export { getDeviceId };
